export default "__VITE_ASSET__Ssr1WZGo__"